import ItemTypes from "../sections/tab_dnd/dnd_types";
import {DropTarget} from "react-dnd";
import {findDOMNode} from "react-dom";

const sectionTarget = {
    hover(props, monitor, component) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;
        if (dragIndex === hoverIndex) {
            return
        }
        const hoverBoundReact = findDOMNode(component).getBoundingClientRect();
        const hoverMiddleY = (hoverBoundReact.bottom - hoverBoundReact.top) / 2;
        const clientOffset = monitor.getClientOffset();
        const hoverClientY = clientOffset.y - hoverBoundReact.top;
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return
        }
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return
        }
        props.moveSection(dragIndex, hoverIndex);
        monitor.getItem().index = hoverIndex;
    },
};


export const pageSectionDropTarget = DropTarget(
    ItemTypes.PAGE_SECTION,
    sectionTarget,
    connect => ({
        connectDropTarget: connect.dropTarget(),
    })
);


// WEBPACK FOOTER //
// ./src/containers/templates/builder/dsdt/section_drop_target.js